import { Component } from '@angular/core';
import { CompanyCode } from '../../shared/enums/company-code';
import { ViewHandlerComponent } from '../../shared/view-handler/view-handler.component';
import { BrandedLoginComponent } from '../branded-login/branded-login.component';
import { StudentLoginComponent } from '../login.student/login.student.component';

@Component({
  selector: 'zbp-login-student-handler',
  template: '<ng-container *ngComponentOutlet="componentToUse | async"></ng-container>',
  standalone: false
})
export class LoginStudentHandlerComponent extends ViewHandlerComponent {
  componentMap = {
    [CompanyCode.ZBPortal]: {
      component: StudentLoginComponent,
    },
    ZbRedesign: {
      component: BrandedLoginComponent,
    }
  };
}
